export enum RoomEngineErrorCode {

    /**
     * IM 重复连接
     */
    IM_CONNECT_DUPLICATED = 'IM_CONNECT_DUPLICATED',

    /**
     * IM 发送消息失败
     */
    IM_SEND_FAILED = 'IM_SEND_FAILED',


    ROOM_IS_FINISHED = 'ROOM_IS_FINISHED',

    NO_STREAM = 'NO_STREAM',

    USER_IS_BLOCKED = 'USER_IS_BLOCKED',

    /**
     * 账号互踢
     */
    LOGIN_ANOTHER = 'LOGIN_ANOTHER',

    /**
     * token校验失败
     */
    ROOM_TOKEN_ERROR = 'ROOM_TOKEN_ERROR',

    /**
     * 回放不存在
     */
    REPLAY_NOT_FOUND = 'REPLAY_NOT_FOUND',

    /**
     * 回放生成中
     */
    REPLAY_GENERATING = 'REPLAY_GENERATING',

    /**
     * 回放生成失败
     */
    REPLAY_GENERATING_ERROR = 'REPLAY_GENERATING_ERROR',

    /**
     * 超过在线人数限制
     */
    ACCOUNT_MAX_ONLINE_EXCEED = 'ACCOUNT_MAX_ONLINE_EXCEED',

    /**
     * 下线原有主播
     */
    SPEAKER_OUT = 'SPEAKER_OUT',
}

export class RoomEngineError extends Error {
    readonly code: RoomEngineErrorCode;

    readonly message: string;

    // eslint-disable-next-line
    readonly data?: any;

    // eslint-disable-next-line
    constructor(code: RoomEngineErrorCode, message?: string, data?: any) {
        super(message);
        this.name = "RoomEngineError";
        this.code = code;
        this.message = "RoomEngineError " + code + ": " + (message ? message : "");
        this.data = data;
    }
}
